import { FC, useEffect } from 'react';
import { ButtonComponent } from '../UI/ButtonComponent/ButtonComponent';
import { AppActions } from '../../redux/AppActions';
import { useAppDispatch } from '../../redux/store';
import { defaultValues } from './model';
import { UserActions } from '../../redux/UserActions';
import './modal.scss';

const LockOverLayComponent: FC = () => {
	const dispatch = useAppDispatch();
	const clearModalContent = () => dispatch(AppActions.setModalContent(undefined));

	const handleCloseModal = () => {
		clearModalContent();
	};

	const handleClearAllFavorites = () => {
		dispatch(UserActions.deteleAllFavorites());
	};

	useEffect(() => {
		const closeIcon = document.getElementById('close-popup');
		if (closeIcon) closeIcon.classList.add('modal-popup-close');
		return () => {
			if (closeIcon) closeIcon.classList.remove('modal-popup-close');
		};
	}, []);

	return (
		<div className='modal-overlay-container'>
			<div className='title-container'>
				<span className='modal-title'>{defaultValues.title}</span>
			</div>
			<div className='body-container'>
				<div className='des-container'>
					<p>{defaultValues.descriptionTitle}</p>
				</div>
				<div className='description-container'>
					<div className='description-content'>
						<span className='description'>{defaultValues.descriptionContent}</span>
					</div>
				</div>
				<div className='buttons-container'>
					<ButtonComponent
						text={defaultValues.keepBtnTitle}
						onClick={handleCloseModal}
						style={'rounded-button secondary'}
					/>
					<ButtonComponent
						text={defaultValues.remBtnTitle}
						onClick={handleClearAllFavorites}
						style={'rounded-button primary cta'}
					/>
				</div>
			</div>
		</div>
	);
};

export default LockOverLayComponent;
